import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import NavbarMob from "../components/NavbarMob";
import loc from "../images/details/loc.png";
import dinner from "../images/details/Dinner.png";
import phone from "../images/details/phone.png";
import id from "../images/details/ID.png";
import suitecase from "../images/details/Suitcase.png";
import company from "../images/details/Company.png";
import Footer from "../components/Footer";
import Navbar2 from "../components/Navbar2";
import { useLocation } from "react-router-dom";
import html2canvas from "html2canvas";
import poster from "../images/download/newone.png";
import QRCode from "qrcode";
import Navbar2Mob from "../components/Navbar2Mob";
import { isLocationRestricted } from "../utils/locationRestrictions";

function Details() {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const [jobDetails, setJobDetails] = useState(null); // State to store job details
    const [error, setError] = useState(null); // State to handle errors
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL; // Assuming you have this in .env file
    const [loading, setLoading] = useState(false); // Track loading status
    const employeeId = sessionStorage.getItem("employeeId");
    const gender = sessionStorage.getItem("gender");

    // console.log("gender:", gender);

    // const [employeeData, setEmployeeData] = useState(null);

    const location = useLocation();
    const { jobId } = location.state || {}; // Extract jobId from state
    // console.log("jobId:", jobId);

    const jobIdStr = jobId.toString();

    const customerType = sessionStorage.getItem("customerType");
    const isMainAdmin = customerType === "mainAdmin";
    const [isJobValid, setIsJobValid] = useState(false);
    const navigate = useNavigate();
    const selectedPlan = sessionStorage.getItem("selectedPlan");
    const companyName = sessionStorage.getItem("customerName");
    const mobileNumber = sessionStorage.getItem("mobileNumber");
    const whatsappNumber = sessionStorage.getItem("whatsappNumber");
    const houseName = sessionStorage.getItem("houseName");
    const experienced = sessionStorage.getItem("experienced");
    // console.log("experienced", experienced);

    const address = sessionStorage.getItem("address");
    const uppercaseAddress = address ? address.toUpperCase() : null;
    // console.log("uppercaseaddress", uppercaseAddress);

    const customerName = sessionStorage.getItem("customerName");

    const [jobPosts, setJobPosts] = useState([]);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [jobToDelete, setJobToDelete] = useState(null);
    const [deletePassword, setDeletePassword] = useState(""); // For password input
    const [passwordError, setPasswordError] = useState("");

    const [contactMap, setContactMap] = useState({});

    // Secure Admin Password (from .env)
    const DELETE_ADMIN_PASSWORD = process.env.REACT_APP_DELETE_ADMIN_PASSWORD;

    // Fetch contact numbers mapping once on mount
    useEffect(() => {
        const fetchContactNumbers = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/api/contact-numbers`);
                const result = await response.json();

                if (result.success) {
                    setContactMap(result.data);
                } else {
                    console.warn("Failed to load contact numbers:", result.message);
                }
            } catch (err) {
                console.error("Error fetching contact numbers:", err);
            }
        };

        fetchContactNumbers();
    }, [apiBaseUrl]);

    const getContactDisplay = (jobLocation) => {
        if (!jobLocation || Object.keys(contactMap).length === 0) {
            return "📞 Contact numbers not available";
        }

        const locLower = jobLocation.toLowerCase().trim();

        // Find matching location (partial match, case-insensitive)
        let matchedNumbers = null;
        for (const [key, value] of Object.entries(contactMap)) {
            if (key !== "default" && locLower.includes(key.toLowerCase())) {
                matchedNumbers = value.numbers || [];
                break;
            }
        }

        // Fallback to default numbers
        if (!matchedNumbers) {
            matchedNumbers = contactMap.default?.numbers || [];
        }

        if (matchedNumbers.length === 0) {
            return "📞 Contact numbers not available";
        }

        // Format: 📞 +91 9999999999, +91 8888888888
        const formatted = matchedNumbers
            .map((num) => {
                // Ensure +91 prefix if missing
                const cleaned = num.replace(/\D/g, ""); // remove spaces, -, etc.
                if (cleaned.length === 10) {
                    return `+91 ${cleaned}`;
                }
                return num; // keep as-is if already formatted
            })
            .join(", ");

        return `📞 ${formatted}`;
    };

    const canApplyForJob = async () => {
        const selectedPlan = sessionStorage.getItem("selectedPlan");
        const employeeId = sessionStorage.getItem("employeeId");

        if (!employeeId) {
            alert("User not logged in.");
            return false;
        }

        const validPlans = ["0", "250", "300", "500"];
        if (!validPlans.includes(selectedPlan)) {
            alert("Please select a valid package to apply for jobs.");
            return false;
        }

        try {
            // Fetch limit status from backend
            const response = await fetch(`${apiBaseUrl}/get-application-limit?employeeId=${employeeId}`);
            const result = await response.json();

            if (!response.ok) {
                alert("Failed to check application limit. Try again.");
                return false;
            }

            if (!result.canApply) {
                alert(
                    `You have reached your daily limit of ${result.dailyLimit} applications.\nRemaining: ${result.remaining}\nTry again tomorrow.`,
                );
                return false;
            }

            // If allowed, record the application
            const recordResponse = await fetch(`${apiBaseUrl}/record-application`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ employeeId }),
            });

            if (!recordResponse.ok) {
                alert("Failed to record application. Please try again.");
                return false;
            }

            return true;
        } catch (error) {
            console.error("Error checking application limit:", error);
            alert("Network error. Please check your connection and try again.");
            return false;
        }
    };

    // useEffect(() => {
    //     const cleanupOldApplications = () => {
    //         const applications = JSON.parse(localStorage.getItem("jobApplications")) || {};
    //         const today = new Date().toISOString().split("T")[0];
    //         const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];

    //         let changed = false;
    //         for (const date in applications) {
    //             if (date < oneWeekAgo) {
    //                 delete applications[date];
    //                 changed = true;
    //             }
    //         }
    //         if (changed) {
    //             localStorage.setItem("jobApplications", JSON.stringify(applications));
    //         }
    //     };

    //     cleanupOldApplications();
    // }, []);

    const Email = sessionStorage.getItem("Email");

    // const employeeId = sessionStorage.getItem('employeeId');
    // console.log("selectedPlan:", selectedPlan);
    // console.log("employeeId:", employeeId);
    const handlePackageClick = async () => {
        if (!customerType) {
            alert("Please login first"); // Alert if not logged in
            return; // Exit the function
        }

        // Check if the customer is an admin
        if (customerType === "admin" || customerType === "mainAdmin") {
            navigate("/companydetails", {
                state: { employeeId: jobDetails.employee_id },
            });
            return; // Exit the function after navigating to company details
        }

        // Proceed with the existing logic for selected plans
        if (["300", "500", "600", "800", "0"].includes(selectedPlan)) {
            try {
                // Fetch data from the API
                const response = await fetch(`${apiBaseUrl}/getPackageSelectionsByCustomerName/${customerName}`);
                const result = await response.json();

                // console.log("resssss", result);

                if (response.ok && result.message === "Data retrieved successfully") {
                    // Check if jobId from jobDetails exists in the API data
                    const jobExists = result.data.some((item) => item.jobId === jobDetails.job_id);

                    if (jobExists) {
                        // Navigate to company details if the jobId matches
                        navigate("/companydetails", {
                            state: { employeeId: jobDetails.employee_id },
                        });
                    } else {
                        alert("Please apply for the job first"); // Alert if jobId is not found
                    }
                } else {
                    alert("Failed to verify the job. Please try again later."); // Handle API failure
                }
            } catch (error) {
                console.error("Error fetching data from API:", error);
                alert("An error occurred while checking job details. Please try again."); // Handle network errors
            }
            return; // Exit the function
        }

        // Default navigation for other plans
        navigate("/packages", {
            state: {
                job: jobDetails.job,
                jobId:
                    jobDetails.manualJobID && jobDetails.manualJobID !== "0" ? jobDetails.manualJobID : jobDetails.job_id,
                location: jobDetails.location,
            },
        });
    };

    useEffect(() => {
        const checkJobDetails = async () => {
            try {
                if (!jobDetails || !jobDetails.job_id) {
                    console.error("Job details are not available.");
                    setIsJobValid(false);
                    return;
                }

                const response = await fetch(`${apiBaseUrl}/getPackageSelectionsByCustomerName/${customerName}`);
                const result = await response.json();

                if (response.ok && result.message === "Data retrieved successfully") {
                    const jobExists = result.data.some((item) => item.jobId === jobDetails.job_id);
                    setIsJobValid(jobExists);
                } else {
                    setIsJobValid(false);
                }
            } catch (error) {
                console.error("Error fetching data from API:", error);
                setIsJobValid(false);
            }
        };

        if (jobDetails && jobDetails.job_id) {
            checkJobDetails();
        } else {
            console.error("Job details are missing or invalid.");
        }
    }, [jobDetails]);

    // Assuming 'selectedPlan', 'jobDetails', and 'customerName' are available in the component's scope
    const Packages2 = async () => {
        if (!customerType) {
            alert("Please login first"); // Alert if not logged in
            return; // Exit the function
        }

        if (!(await canApplyForJob())) {
            setLoading(false);
            return; // Stop if limit exceeded or error
        }

        const gender = sessionStorage.getItem("gender")?.toLowerCase();
        const jobGender = jobDetails.gender_type?.toLowerCase();

        // console.log("gender:", gender, "jobGender:", jobGender);

        // ✅ Check gender compatibility
        const genderAllowed = gender === jobGender || jobGender === "male/female" || gender === "male/female";

        if (!genderAllowed) {
            alert(`This job is only for ${jobDetails.gender_type}.`);
            return; // Stop execution
        }

        setLoading(true); // Start loading

        if (
            selectedPlan === "300" ||
            selectedPlan === "500" ||
            selectedPlan === "600" ||
            selectedPlan === "800" ||
            selectedPlan === "0"
        ) {
            try {
                // Fetch additional data from APIs based on employeeId
                const fetchEmployeeData = async () => {
                    try {
                        // First, try the primary API
                        const response = await fetch(`${apiBaseUrl}/employee/${jobDetails.employee_id}`);
                        if (!response.ok) {
                            throw new Error("Employee not found in primary API");
                        }
                        const data = await response.json();
                        return {
                            additionalCompanyName: data.employee.company_name, // Rename key
                            additionalMobileNumber: data.employee.mobile_number, // Rename key
                            additionalLocation: data.employee.location, // Rename key
                        };
                    } catch (error) {
                        // console.log("Primary API failed:", error.message);

                        // Try the fallback API if the primary fails
                        try {
                            const fallbackResponse = await fetch(`${apiBaseUrl}/staff/${jobDetails.employee_id}`);
                            if (!fallbackResponse.ok) {
                                throw new Error("Employee not found in fallback API");
                            }
                            const fallbackData = await fallbackResponse.json();
                            return {
                                additionalCompanyName: fallbackData.employee.companyName, // Rename key
                                additionalMobileNumber: fallbackData.employee.mobileNumber, // Rename key
                                additionalLocation: fallbackData.employee.address, // Rename key
                            };
                        } catch (fallbackError) {
                            // console.log("Fallback API failed:", fallbackError.message);
                            throw fallbackError;
                        }
                    }
                };

                const additionalData = await fetchEmployeeData();

                // Prepare data to send to the backend
                const payload = {
                    employeeId: jobDetails.employee_id,
                    customerName: companyName,
                    houseName: houseName,
                    experienced: experienced,
                    jobId: jobDetails.job_id,
                    whatsappNumber: whatsappNumber,
                    mobileNumber: mobileNumber,
                    Email: Email,
                    additionalCompanyName: jobDetails.shopName, // New data
                    additionalMobileNumber: jobDetails.whatsapp_number, // New data
                    additionalLocation: jobDetails.location,
                };

                // console.log("payload", payload);

                const currentDate = new Date();
                const formattedDate = `${String(currentDate.getDate()).padStart(2, "0")}/${String(
                    currentDate.getMonth() + 1,
                ).padStart(2, "0")}/${currentDate.getFullYear()}`;

                // Send data to backend
                const response = await fetch(`${apiBaseUrl}/savePackageSelection`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (response.ok) {
                    // console.log("Data saved successfully");

                    // Save to localStorage
                    const appliedDate = new Date().toISOString().split("T")[0];
                    const phoneNumber = jobDetails.whatsapp_number;
                    const jobTitle = jobDetails.job;
                    const manualJobID =
                        jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                            ? jobDetails.manualJobID
                            : jobDetails.job_id;

                    let appliedJobs = JSON.parse(localStorage.getItem("appliedJobs")) || [];

                    appliedJobs.push({
                        jobId: jobDetails.job_id,
                        manualJobID: manualJobID,
                        jobTitle: jobTitle,
                        phoneNumber: phoneNumber,
                        appliedDate: appliedDate,
                        location: jobDetails.location,
                    });

                    localStorage.setItem("appliedJobs", JSON.stringify(appliedJobs));

                    const destinationNumber = `91${jobDetails.whatsapp_number}`;

                    // console.log(destinationNumber);

                    // Prepare WhatsApp message
                    const whatsappPayload = {
                        to: destinationNumber, // Destination WhatsApp number
                        message: `Dear Employer, \n${companyName} (ID: *${employeeId}*), താങ്കളുടെ സ്ഥാപനത്തിൽ ഉള്ള *${
                            jobDetails.job
                        }* (Job ID: *${
                            jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                                ? jobDetails.manualJobID
                                : jobDetails.job_id
                        }*) ജോലി ഒഴിവിന് www.riyahubs.com വഴി ${formattedDate} തീയതിയിൽ ജോലിക്ക് വേണ്ടിയുള്ള അപേക്ഷ സമർപ്പിച്ചിരിക്കുന്നു.
                                പുതിയ ജോലി ഒഴിവുകൾ ഉണ്ടെങ്കിലും നിലവിൽ ഉള്ള ജോലി ഒഴിവുകൾ ഫിൽ ആയാലും അറിയിക്കുക`,
                    };

                    // Send data to the WhatsApp API
                    const whatsappResponse = await fetch(`${apiBaseUrl}/send-whatsapp-apply`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(whatsappPayload),
                    });

                    if (whatsappResponse.ok) {
                        const result = await whatsappResponse.json();
                        if (result.success) {
                            window.location.reload();
                            // console.log("WhatsApp message sent successfully");
                            alert("Package applied and confirmation sent to Employer via WhatsApp!");
                        } else {
                            console.warn("WhatsApp failed but job applied:", result.message);
                            alert("Job applied successfully! (WhatsApp notification failed)");
                        }
                    } else {
                        console.error("Failed to send WhatsApp message");
                        alert("Job applied successfully! \nMake a call to the employer  \n( റിയ ഹബ് ജോബ്‌ കൺസൾട്ടൻസി യിൽ നിന്നും കിട്ടിയ നമ്പർ ആണ്. ജോലിയുടെ കാര്യം അറിയാൻ ആണ് എന്ന് വിളിച്ച് സംസാരിക്കുക.)");
                    }

                    window.location.reload();
                } else {
                    console.error("Failed to save data");
                    alert("Failed to apply. Please try again.");
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error:", error);
                alert("An error occurred. Please try again.");
                setLoading(false);
            }
        } else {
            navigate("/packages", {
                state: {
                    job: jobDetails.job,
                    jobId:
                        jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                            ? jobDetails.manualJobID
                            : jobDetails.job_id,
                    location: jobDetails.location,
                },
            });
            setLoading(false); // End loading
        }
    };

    // const empData = jobDetails?.employee_id || null;
    // console.log("empppppppppppppp:",empData);

    // useEffect(() => {
    //     if (!empData) {
    //         console.log("empData is null or undefined, skipping API call.");
    //         return; // Stop execution if empData is null
    //     }

    //     const fetchCompanyData = async () => {
    //         console.log("Fetching data for empData:", empData);

    //         try {
    //             const response = await fetch(`${apiBaseUrl}/employee/${empData}`);
    //             if (!response.ok) {
    //                 throw new Error('Employee not found in primary API');
    //             }
    //             const data = await response.json();
    //             setEmployeeData(data.employee);
    //         } catch (error) {
    //             console.log("Primary API failed:", error.message);
    //             try {
    //                 console.log("Fetching fallback data for empData:", empData);

    //                 const fallbackResponse = await fetch(`${apiBaseUrl}/staff/${empData}`);
    //                 if (!fallbackResponse.ok) {
    //                     throw new Error('Employee not found in fallback API');
    //                 }
    //                 const fallbackData = await fallbackResponse.json();
    //                 setEmployeeData(fallbackData.employee);
    //             } catch (fallbackError) {
    //                 console.log("Fallback API failed:", fallbackError.message);
    //                 setError(fallbackError.message);
    //             }
    //         }
    //     };

    //     fetchCompanyData();
    // }, [empData]); // Ensure useEffect runs when empData changes
    //  // Ensure this dependency is correct

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (jobId) {
            const cleanedJobId = jobIdStr.replace(/^['"]|['"]$/g, ""); // This removes surrounding quotes

            const encodedJobId = encodeURIComponent(cleanedJobId);

            fetch(`${apiBaseUrl}/getjobposts/${encodedJobId}`)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {
                    // console.log("Fetched job data:", data); // Log the fetched data to inspect the response

                    // Check if enable is 'on' as a string (not boolean)
                    if (isLocationRestricted(data.location)) {
                        setJobDetails(null);
                        setError("This job is not available.");
                    } else if (data.enable && data.enable.toLowerCase() === "on") {
                        setJobDetails(data);
                    } else {
                        setJobDetails(null);
                        setError("This job is not enabled.");
                    }
                })
                .catch((error) => {
                    setError("Error fetching job details. Please try again later.");
                    console.error("Error fetching job details:", error);
                });
        }
    }, [jobId, apiBaseUrl]);

    const downloadStyledImage = () => {
        const container = document.getElementById("jobDetailsContainer");
        const locations = jobDetails.location.split(","); // Split the locations by commas

        container.style.display = "block"; // Show the container temporarily for capture

        // Set the container dimensions to portrait mode for a standard page size
        container.style.width = "800px";
        container.style.height = "1120px";

        // Generate the QR code with the specified link
        const qrCanvas = document.createElement("canvas");
        QRCode.toCanvas(qrCanvas, "https://www.riyahubs.com", {
            width: 100,
            margin: 2,
        })
            .then(() => {
                // Append QR code to the container
                qrCanvas.classList.add("absolute", "bottom-10", "right-10"); // Position it as needed
                container.appendChild(qrCanvas);

                // Loop through each location and create separate images
                locations.forEach((location, index) => {
                    // Modify the location value in the container
                    const locationElement = container.querySelector(".location"); // Find the location span
                    locationElement.textContent = `Location: ${location.trim()}`; // Update the location text

                    // Capture the container with html2canvas for each location
                    html2canvas(container, { scale: 2, width: 800, height: 1120 })
                        .then((canvas) => {
                            const link = document.createElement("a");
                            link.href = canvas.toDataURL("image/png");
                            link.download = `job_details_location_${index + 1}.png`; // Download with dynamic name based on location
                            link.click();
                        })
                        .catch((error) => {
                            console.error("Error capturing image:", error);
                        });
                });

                // Clean up
                container.removeChild(qrCanvas); // Remove QR code after download
                container.style.display = "none"; // Hide the container again after download
                container.style.width = ""; // Reset width
                container.style.height = ""; // Reset height
            })
            .catch((error) => {
                console.error("Error generating QR code:", error);
            });
    };

    if (error) {
        return <div>{error}</div>; // Show error message
    }

    if (!jobDetails) {
        return <div>Loading job details...</div>; // Loading state
    }

    const editJobPost = (jobId) => {
        if (!jobDetails) return;

        navigate("/editjobpost", {
            state: {
                jobId,
                employeeId: jobDetails.employee_id, // correct: original job owner
                manualJobID: jobDetails.manualJobID && jobDetails.manualJobID !== "0" ? jobDetails.manualJobID : null,
                jobData: jobDetails, // full data for prefill
            },
        });
    };

    // Open confirmation modal
    const openDeleteModal = (jobId) => {
        setJobToDelete(jobId);
        setDeletePassword("");
        setPasswordError("");
        setShowDeleteModal(true);
    };

    // Cancel deletion
    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setJobToDelete(null);
        setDeletePassword("");
        setPasswordError("");
    };

    // Confirm and delete job post
    const confirmDelete = async () => {
        // Validate password (assuming DELETE_ADMIN_PASSWORD is defined at top)
        if (deletePassword !== DELETE_ADMIN_PASSWORD) {
            setPasswordError("Incorrect password. Deletion denied.");
            return;
        }

        if (!jobToDelete) return;

        try {
            const response = await fetch(`${apiBaseUrl}/jobpost/${jobToDelete}`, {
                method: "DELETE",
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || "Network response was not ok");
            }

            const data = await response.json();

            if (data.success) {
                // Remove the deleted job from state
                setJobPosts((prevJobs) => prevJobs.filter((job) => job.job_id !== jobToDelete));
                closeDeleteModal();
                alert("Job post deleted successfully");
                navigate(-1);
            } else {
                setPasswordError("Failed to delete: " + (data.message || "Unknown error"));
            }
        } catch (error) {
            console.error("Error deleting job post:", error);
            setPasswordError("Failed to delete job post: " + error.message);
            // Do NOT close modal on error — let user retry password
        }
    };

    return (
        <div className="min-h-screen flex flex-col ">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>

            <div className="flex flex-col gap-8 lg:px-12 px-3 mt-12 pb-12">
                <div className="flex flex-row justify-end w-full gap-2">
                    {/* <div
                        className="h-[42px] lg:w-[13%] w-[40%] bg-[#3B3D3B] hover:bg-[#2f302f] rounded-[10px] flex justify-center items-center text-base font-[600] font-display text-[white] cursor-pointer"
                        onClick={handlePackageClick}
                    >
                        Company Details
                    </div> */}

                    {/* ✅ Apply / Purchase logic based on package */}
                    {(() => {
                        const blockedLocations = ["ernakulam", "kochi", "kakkanad"];
                        const location = jobDetails?.location?.toLowerCase() || "";
                        const isBlocked = selectedPlan === "500" && blockedLocations.some((loc) => location.includes(loc));
                        const hasPackage = selectedPlan && selectedPlan !== "null";

                        if (isBlocked || isJobValid) return null;

                        if (hasPackage) {
                            return (
                                <div
                                    className="p-4 bg-[#339030] hover:bg-[#267824] rounded-[10px] flex justify-center items-center text-base font-[600] font-display text-[white] cursor-pointer transition-all"
                                    onClick={Packages2}
                                >
                                    {loading ? (
                                        <div className="flex items-center gap-2">
                                            <div className="w-5 h-5 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                                            <span>Applying...</span>
                                        </div>
                                    ) : (
                                        <span>Apply Now</span>
                                    )}
                                </div>
                            );
                        }

                        // No package: prompt purchase and navigate to packages
                        return (
                            <div
                                className="p-4 bg-[#E22E37] hover:bg-[#c71d28] rounded-[10px] flex justify-center items-center text-base font-[600] font-display text-[white] cursor-pointer transition-all"
                                onClick={() =>
                                    navigate("/packages", {
                                        state: {
                                            job: jobDetails.job,
                                            jobId:
                                                jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                                                    ? jobDetails.manualJobID
                                                    : jobDetails.job_id,
                                            location: jobDetails.location,
                                        },
                                    })
                                }
                            >
                                Purchase a package to apply
                            </div>
                        );
                    })()}

                    {(customerType === "admin" || customerType === "mainAdmin") && (
                        <div
                            className="h-[42px] lg:w-[13%] w-[40%] bg-[#282d55] hover:bg-[#1d2246] rounded-[10px] flex justify-center items-center text-lg font-[600] font-display text-[white] cursor-pointer"
                            onClick={downloadStyledImage}
                        >
                            download
                        </div>
                    )}
                    {(customerType === "admin" || customerType === "mainAdmin") && (
                        <div
                            className="h-[42px] lg:w-[13%] w-[40%] bg-[#d22989] hover:bg-[#be3683] rounded-[10px] flex justify-center items-center text-lg font-[600] font-display text-[white] cursor-pointer"
                            onClick={() => editJobPost(jobDetails.job_id)} // ← FIXED: pass job_id here
                        >
                            Edit
                        </div>
                    )}
                    {customerType === "mainAdmin" && (
                        <div
                            className="h-[42px] lg:w-[13%] w-[40%] bg-[#e0c6d5] hover:bg-[#be3683] rounded-[10px] flex justify-center items-center text-lg font-[600] font-display text-[white] cursor-pointer"
                            onClick={() => openDeleteModal(jobDetails.job_id)}
                        >
                            Delete
                        </div>
                    )}
                </div>

                <div className="w-full flex flex-col gap-4">
                    {!isJobValid && (
                        <div className="w-full flex flex-col gap-4">
                            <span className="text-xl font-[700] font-display text-left">{jobDetails.job}</span>
                            <span className="text-lg font-[400] font-display text-left">{jobDetails.job_title}</span>
                        </div>
                    )}

                    <div className="flex flex-col w-full h-auto gap-2">
                        {/* Always show Job Id */}
                        {!isJobValid && (
                            <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                    <img src={id} alt="id" />
                                    <span className="text-[#B3B3B3] text-lg font-[500] font-display">Job Id</span>
                                </div>

                                <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                    {jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                                        ? jobDetails.manualJobID
                                        : jobDetails.job_id}
                                </div>
                            </div>
                        )}

                        {/* =============== AFTER APPLICATION: Show ONLY these 5 fields =============== */}
                        {isJobValid && companyName !== "Hanna" ? (
                            <>
                                {/* 1. Job Id - already shown above */}

                                {/* 2. Company Type */}
                                {/* <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                    <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                        <img src={company} alt="company" />
                                        <span className="text-[#B3B3B3] text-lg font-[500] font-display">Company Type</span>
                                    </div>
                                    <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                        {jobDetails.company_type}
                                    </div>
                                </div> */}

                                {/* 3. Company Name */}
                                <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                    <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                        <img src={company} alt="shop" />
                                        <span className="text-[#B3B3B3] text-lg font-[500] font-display">Company Name</span>
                                    </div>
                                    <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                        {jobDetails.shopName}
                                    </div>
                                </div>

                                {/* 4. Company Address */}
                                <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                    <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                        <img src={loc} alt="address" />
                                        <span className="text-[#B3B3B3] text-lg font-[500] font-display">
                                            Company Address
                                        </span>
                                    </div>
                                    <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                        {jobDetails.address}
                                    </div>
                                </div>

                                {/* 5. Manager Number */}
                                <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                    <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                        <img src={phone} alt="phone" />
                                        <span className="text-[#B3B3B3] text-lg font-[500] font-display">
                                            Manager Number
                                        </span>
                                    </div>
                                    <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                        {jobDetails.whatsapp_number}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                {/* =============== BEFORE APPLICATION: Show original fields (unchanged) =============== */}
                                {/* Company Type (existing condition) */}
                                {(selectedPlan === "300" ||
                                    selectedPlan === "500" ||
                                    selectedPlan === "600" ||
                                    selectedPlan === "800" ||
                                    selectedPlan === "0" ||
                                    customerType === "admin" ||
                                    customerType === "mainAdmin") && (
                                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                            <img src={company} alt="company" />
                                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">
                                                Company Type
                                            </span>
                                        </div>
                                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                            {jobDetails.company_type}
                                        </div>
                                    </div>
                                )}
                                {isMainAdmin && (
                                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                            <img src={suitecase} alt="job" />
                                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Job Type</span>
                                        </div>
                                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                            {jobDetails.job_type}
                                        </div>
                                    </div>
                                )}
                                {/* Location */}
                                <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                    <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                        <img src={loc} alt="loc" />
                                        <span className="text-[#B3B3B3] text-lg font-[500] font-display">Location</span>
                                    </div>
                                    <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                        {jobDetails.location}
                                    </div>
                                </div>
                                {/* Address (only if previously allowed) */}
                                {companyName !== "Hanna" &&
                                    (customerType === "admin" ||
                                        customerType === "mainAdmin" ||
                                        (isJobValid && ["300", "500", "600", "800", "0"].includes(selectedPlan))) && (
                                        <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                            <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                                <img src={loc} alt="address" />
                                                <span className="text-[#B3B3B3] text-lg font-[500] font-display">
                                                    Address
                                                </span>
                                            </div>
                                            <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                                {jobDetails.address}
                                            </div>
                                        </div>
                                    )}

                                {/* Area */}
                                {selectedPlan > 0 && jobDetails?.area && (
                                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                            <img src={loc} alt="address" />
                                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Area</span>
                                        </div>
                                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                            {jobDetails.area}
                                        </div>
                                    </div>
                                )}

                                {isMainAdmin && (
                                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Vacancy</span>
                                        </div>
                                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                            {jobDetails.vacancy}
                                        </div>
                                    </div>
                                )}
                                {/* Food & Accommodation */}
                                {(selectedPlan === "300" ||
                                    selectedPlan === "500" ||
                                    selectedPlan === "600" ||
                                    selectedPlan === "800" ||
                                    customerType === "admin" ||
                                    customerType === "mainAdmin") && (
                                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                            <img src={dinner} alt="food" />
                                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">
                                                Food & Accomodation
                                            </span>
                                        </div>
                                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                            {jobDetails.food_type}
                                        </div>
                                    </div>
                                )}
                                {/* Salary */}
                                <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                    <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                        <span className="text-[#B3B3B3] text-lg font-[500] font-display">Salary</span>
                                    </div>
                                    <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                        {jobDetails.min_salary > 0 && jobDetails.max_salary > 0
                                            ? `${jobDetails.min_salary} - ${jobDetails.max_salary}`
                                            : jobDetails.min_salary > 0
                                              ? jobDetails.min_salary
                                              : jobDetails.max_salary > 0
                                                ? jobDetails.max_salary
                                                : jobDetails.salaryType}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <ul className="border-2 border-[#E3EAF1]"></ul>
                {(selectedPlan === "300" ||
                    selectedPlan === "500" ||
                    selectedPlan === "600" ||
                    selectedPlan === "800" ||
                    selectedPlan === "0" ||
                    customerType === "admin" ||
                    customerType === "mainAdmin") && (
                    <div className="flex flex-col w-full gap-4">
                        {!isJobValid && (
                            <>
                                <span className="text-xl font-[700] font-display text-left">Job Desccription</span>
                                <span className="text-lg font-[400] font-display text-left">
                                    {jobDetails.job_description}
                                </span>
                            </>
                        )}
                    </div>
                )}

                <span className="text-xl font-[700] font-display text-left">Requirements</span>

                <div className="flex flex-col w-full h-auto gap-2">
                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Required Gender</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.gender_type}
                        </div>
                    </div>

                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Qualification</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.qualification}
                        </div>
                    </div>

                    {(selectedPlan === "300" ||
                        selectedPlan === "500" ||
                        selectedPlan === "600" ||
                        selectedPlan === "800" ||
                        customerType === "admin" ||
                        customerType === "mainAdmin") && (
                        <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                            <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                                <span className="text-[#B3B3B3] text-lg font-[500] font-display">Experience Required</span>
                            </div>
                            <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                {jobDetails.experienceType}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* <div className='grid lg:grid-cols-6 grid-cols-3 w-full lg:px-12 px-3 gap-12 mt-12 pb-8'>
                <div className='h-[56px] w-full bg-[#52CE60] rounde-[10px] flex justify-center items-center rounded-[10px]'>
                    <img src={wa} alt="wa" />
                </div>
                <div className='h-[56px] w-full bg-[#DCE6EA] rounde-[10px] flex justify-center items-center rounded-[10px]'>
                    <img src={mail} alt="wa" />
                </div>

                <div className='h-[56px] w-full bg-[#1877F2] rounde-[10px] flex justify-center items-center rounded-[10px]'>
                    <img src={fb} alt="wa" />
                </div>
                <div className='h-[56px] w-full bg-gradient-to-r from-[#f9ce34] via-[#ee2a7b] to-[#6228d7]  rounde-[10px] flex justify-center items-center rounded-[10px]'>
                    <img src={insta} alt="wa" />
                </div>
                <div className='h-[56px] w-full bg-[#000000] rounde-[10px] flex justify-center items-center rounded-[10px]'>
                    <img src={x} alt="wa" />
                </div>
                <div className='h-[56px] w-full bg-[#239CD7] rounde-[10px] flex justify-center items-center rounded-[10px]'>
                    <img src={telegram} alt="wa" />
                </div>
            </div> */}

            <div id="jobDetailsContainer" className="relative" style={{ display: "none", height: "100vh", width: "100vw" }}>
                <img src={poster} alt="main" style={{ width: "100%", height: "100%" }} />
                <div className="absolute inset-0 flex flex-row w-[100%] h-[100%] ">
                    <div className="px-12   flex flex-col">
                        <div className="text-[#E22E37] text-9xl font-[700] mt-[25%] text-left font-display">
                            WE ARE HIRING!
                        </div>
                        <div className="w-auto max-w-[70%] h-auto bg-[#E22E37] flex justify-center items-center text-center text-[white] font-[800] text-3xl mt-[10%] rounded-[10px] font-display">
                            {" "}
                            <span className="mb-5">{jobDetails.job}</span>
                        </div>
                        <div className="w-[90%] h-auto bg-[white] rounded-[10px] px-12 py-6 flex flex-col gap-5 mt-[5%]">
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display text-left">
                                <span>{jobDetails.job_title}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Job ID :{" "}
                                <span>
                                    {jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                                        ? jobDetails.manualJobID
                                        : jobDetails.job_id}
                                </span>{" "}
                            </span>

                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Salary :
                                <span>
                                    {jobDetails.min_salary > 0 && jobDetails.max_salary > 0
                                        ? `${jobDetails.min_salary} - ${jobDetails.max_salary}`
                                        : jobDetails.min_salary > 0
                                          ? jobDetails.min_salary
                                          : jobDetails.max_salary > 0
                                            ? jobDetails.max_salary
                                            : jobDetails.salaryType}
                                </span>
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Qualification : <span>{jobDetails.qualification}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Gender :{" "}
                                <span>
                                    {jobDetails.gender_type === "MALE"
                                        ? "BOYS"
                                        : jobDetails.gender_type === "FEMALE"
                                          ? "GIRLS"
                                          : jobDetails.gender_type === "MALE/FEMALE"
                                            ? "BOYS/GIRLS"
                                            : jobDetails.gender_type}
                                </span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display location">
                                Location: <span>{jobDetails.location}</span>
                            </span>
                        </div>
                        <div className="flex flex-col mt-[5%] gap-3">
                            <div className="text-[#E22E37] font-[700] text-3xl font-display text-left">
                                Send your CV & Portfolio to:
                            </div>
                            {/* Dynamic phone numbers */}
                            <div className="text-[#E22E37] font-[700] text-3xl font-display text-left">
                                {getContactDisplay(jobDetails?.location)}
                            </div>

                            <div className=" font-[900] text-2xl font-display text-center">WWW.RIYAHUBS.COM</div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Custom Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white rounded-[20px] p-8 max-w-sm w-full mx-4 shadow-2xl">
                        <h2 className="text-2xl font-bold text-center mb-4 text-red-600">Confirm Delete</h2>
                        <p className="text-center text-gray-700 mb-6">
                            Are you sure you want to permanently delete this job post?
                            <br />
                            <strong>This action cannot be undone.</strong>
                        </p>

                        {/* Password Input */}
                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Admin Password Required</label>
                            <input
                                type="password"
                                value={deletePassword}
                                onChange={(e) => {
                                    setDeletePassword(e.target.value);
                                    setPasswordError(""); // Clear error on typing
                                }}
                                placeholder="Enter admin password"
                                className="w-full px-4 py-3 border-2 border-gray-300 rounded-[12px] focus:outline-none focus:border-red-500"
                                autoFocus
                            />
                            {passwordError && <p className="text-red-500 text-sm mt-2 text-center">{passwordError}</p>}
                        </div>

                        <div className="flex justify-center gap-4">
                            <button
                                onClick={closeDeleteModal}
                                className="px-6 py-3 bg-gray-300 text-black rounded-[12px] font-semibold hover:bg-gray-400 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={confirmDelete}
                                className="px-6 py-3 bg-red-600 text-white rounded-[12px] font-semibold hover:bg-red-700 transition disabled:opacity-50"
                                disabled={!deletePassword} // Disable if no password entered
                            >
                                Delete Permanently
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="mt-12">
                <Footer />
            </div>
        </div>
    );
}

export default Details;
